// Gate do painel admin da Trilha: escopo "admin" no JWT emitido pelo
// core-schief-ai — ou seja, quem pode acessar é definido no core (pelo CTO),
// não no front. Mesmo modelo de Security scopes usado nos backends da casa.
// F1: este gate é só UX (o painel opera apenas dados locais do navegador);
// em F2, o endpoint de conteúdo precisa validar o escopo server-side.
import {decodeToken} from 'react-jwt'
import {CookiesService} from '../../services/Cookie.service'

interface PayloadToken {
    scopes?: string[]
}

export function usuarioTemEscopoAdmin(): boolean {
    // Liberação TEMPORÁRIA para desenvolvimento local: defina
    // VITE_TRILHA_ADMIN_LIBERADO=true no .env da máquina. O prefixo
    // import.meta.env.DEV é o que garante o "nunca em ambiente": em build de
    // produção DEV vira `false` literal e o bundler elimina o ramo por dead
    // code — o bypass nem existe no bundle. O login comum do core local emite
    // scopes vazios; em produção o acesso é exclusivamente pelo escopo do JWT.
    if (
        import.meta.env.DEV &&
        import.meta.env.VITE_TRILHA_ADMIN_LIBERADO === 'true'
    ) {
        return true
    }
    try {
        const authData = new CookiesService().getAuthData()
        if (!authData?.access_token) return false
        const payload = decodeToken<PayloadToken>(authData.access_token)
        return Boolean(payload?.scopes?.includes('admin'))
    } catch {
        return false
    }
}
